import { useA11yAudit } from '../hooks/useA11yAudit';

/**
 * Item 100: Wrapper component that runs a11y audit in development.
 * Must be rendered inside a Router context.
 */
export function A11yAuditProvider({ children }: { children: React.ReactNode }) {
  useA11yAudit();
  return <>{children}</>;
}
